import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { Chip } from '../../../../models/common/chip.model';
import { Company } from '../../../../models/common/company.model';
import { PhotographerService } from '../../../../services/photographer.service';
import { TopbarService } from '../../../../shared/services/topbar.service';

@Component({
  standalone: false,
  selector: 'bt-get-hired',
  templateUrl: './get-hired.component.html',
  styleUrls: ['./get-hired.component.scss']
})
export class GetHiredComponent implements OnInit, OnDestroy {

  public chips: Chip[];

  public companies: { data?: Company[], dataToView?: Company[], areFiltered?: boolean, searchText?: string } = { searchText: '' };
  public tmpCompany: Company;
  public loaderId = 'loaderId';

  private subscription = new Subscription();

  constructor(
    private topbarService: TopbarService,
    private photoService: PhotographerService
  ) {
    this.searchTextSubscription();
  }

  public ngOnInit() {
    this.getCompanies();
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public onSendCollaborationRequest(item: Company) {
    this.photoService.sendCollaborationRequest(item.companyId).subscribe(() => {
    });
  }

  private getCompanies() {
    this.photoService.getCompanies(this.loaderId).subscribe(data => {
      this.companies.data = data;
      this.setCompaniesToView();
    });
  }

  private searchTextSubscription() {
    this.subscription.add(this.topbarService.searchTextSubscribe.subscribe(data => {
      if (data !== this.companies.searchText) {
        this.companies.searchText = data;
        this.setCompaniesToView(true);
      }
    }));
  }

  private setCompaniesToView(fromSearch?: boolean) {
    const search = this.companies.searchText ? this.companies.searchText.toLowerCase() : '';
    this.companies.areFiltered = !!search && (this.companies.areFiltered || fromSearch);
    this.companies.dataToView = this.companies.data.filter(x => x.companyName.toLowerCase().indexOf(search) >= 0);
  }
}
